module.exports = __webpack_public_path__ + "asset/image-Scrissors-e4c1f15a1a5172bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Scrissors.svg
// module id = +sfM
// module chunks = 0